import { useState, useEffect } from "react";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import ChatSidebar from "../../components/chats/ChatSidebar";
import ChatBox from "../../components/chats/ChatBox";
import PageMeta from "../../components/common/PageMeta";
import { ChatThread, listChatThreads } from "../../lib/api/chat";

export default function Chats() {
  const [selectedThread, setSelectedThread] = useState<ChatThread | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadThreads = async () => {
      try {
        const loadedThreads = await listChatThreads();
        // Auto-select first thread if available
        if (loadedThreads.length > 0) {
          setSelectedThread(loadedThreads[0]);
        }
      } catch (error) {
        console.error("[Chats] Error loading threads:", error);
      } finally {
        setLoading(false);
      }
    };

    loadThreads();
  }, []);

  return (
    <>
      <PageMeta
        title="React.js Chat Dashboard | TailAdmin - React.js Admin Dashboard Template"
        description="This is React.js Chat Dashboard page for TailAdmin - React.js Tailwind CSS Admin Dashboard Template"
      />
      <PageBreadcrumb pageTitle="Chats" />
      <div className="h-[calc(100vh-150px)] overflow-hidden sm:h-[calc(100vh-174px)]">
        <div className="flex flex-col h-full gap-6 xl:flex-row xl:gap-5">
          {/* <!-- Chat Sidebar Start --> */}
          <ChatSidebar />
          {/* <!-- Chat Sidebar End --> */}

          {/* <!-- Chat Box Start --> */}
          {loading ? (
            <div className="flex-1 flex items-center justify-center rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
              <div className="text-center">
                <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-brand-500 border-r-transparent mb-3"></div>
                <p className="text-gray-600 dark:text-gray-400">Loading chats...</p>
              </div>
            </div>
          ) : selectedThread ? (
            <ChatBox thread={selectedThread} />
          ) : (
            <div className="flex-1 flex items-center justify-center rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
              <div className="text-center">
                <p className="text-gray-600 dark:text-gray-400">No chat threads available</p>
                <p className="text-sm text-gray-500 dark:text-gray-500 mt-2">Create a plugging plan to start a conversation</p>
              </div>
            </div>
          )}
          {/* <!-- Chat Box End --> */}
        </div>
      </div>
    </>
  );
}
